import(/* webpackMode: "eager" */ "C:\\Users\\jimfa\\OneDrive\\Documents\\GitHub\\JDI-Website\\node_modules\\next\\dist\\client\\app-dir\\link.js");
;
import(/* webpackMode: "eager", webpackExports: ["AppsWeb"] */ "C:\\Users\\jimfa\\OneDrive\\Documents\\GitHub\\JDI-Website\\src\\components\\AppsWeb.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DeferredHomeHeroEffects"] */ "C:\\Users\\jimfa\\OneDrive\\Documents\\GitHub\\JDI-Website\\src\\components\\DeferredHomeHeroEffects.tsx");
